"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTAIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
function CTAIcon(props) {
    var _a;
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8184 12C20.8184 15.8576 17.6979 18.9865 13.8434 19V17C16.5933 16.9865 18.8184 14.7531 18.8184 12C18.8184 9.24692 16.5933 7.01353 13.8434 7.00002V5C17.6979 5.01353 20.8184 8.14235 20.8184 12ZM15 12L13.1662 13.8338L9.49438 17.4944L9.49668 13L4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11L9.4977 11L9.5 6.5L15 12Z", fill: (_a = props.color) !== null && _a !== void 0 ? _a : theme.colors.grey90 }) })));
}
exports.CTAIcon = CTAIcon;
//# sourceMappingURL=cta_icon.js.map